export default __webpack_public_path__ + "41a9274088cbb1d40b717efc0feace3d.woff2";